import React from "react";
import { Box, Paper, Typography, Button } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useTranslation } from "react-i18next";

// WhatsApp contact number for credit top-ups (digits only, no "+").
// Optionally override at build time with REACT_APP_WHATSAPP_NUMBER.
const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "14382556657";

const TopUpCredits = () => {
  const { t } = useTranslation();

  const handleContactSupport = () => {
    const message = encodeURIComponent(t("topUpCredits.whatsappMessage"));
    window.open(
      `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 4, maxWidth: 600, mx: "auto", textAlign: "center" }}>
        <Typography variant="h5" gutterBottom>
          {t("topUpCredits.title")}
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          {t("topUpCredits.contactSupportText")}
        </Typography>
        <Button
          variant="contained"
          size="large"
          startIcon={<WhatsAppIcon />}
          onClick={handleContactSupport}
        >
          {t("topUpCredits.contactSupportButton")}
        </Button>
      </Paper>
    </Box>
  );
};

export default TopUpCredits;
